import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BolgeNavSettled.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CategoryInfiniteContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/DistrictSetter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchPageGTMReporter"] */ "/app/src/components/SearchPageGTMReporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SearchResultsListing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SearchResultsView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/seo/PermalinkFaqAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SeoView"] */ "/app/src/components/seo/SeoView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SortAndFilterOptionsContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TownStoryStrip"] */ "/app/src/components/TownStoryStrip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UrunlerListingGate","UrunlerListingNavigationProvider"] */ "/app/src/contexts/UrunlerListingNavigationContext.tsx");
